import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";
import { dateBadge, sportName, distanceList } from "@/lib/helpers";
import { SportIcon } from "./SportIcon";
import { SaveButton } from "./SaveButton";

export function RaceCard({ race, onSaveChange }) {
  const b = dateBadge(race.date);
  const distances = distanceList(race);
  return (
    <div data-testid={`race-card-${race.slug}`}
      className="group bg-white rounded-xl overflow-hidden border border-slate-200 hover:border-[#22d3ee] hover:shadow-xl transition-all duration-300 flex flex-col h-full">
      <div className="relative h-48 sm:h-52 w-full overflow-hidden bg-slate-900">
        <Link to={`/race/${race.slug}`}>
          <img src={race.hero_image} alt={race.name} loading="lazy"
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
        </Link>
        <div className="absolute top-3 left-3 bg-[#0a1420]/90 text-white backdrop-blur-sm border border-slate-700/80 rounded-md px-2.5 py-1.5 text-center leading-tight shadow-lg z-10">
          <div className="font-display font-black text-xl text-[#22d3ee]">{b.day}</div>
          <div className="font-display font-bold text-[10px] tracking-widest">{b.month}</div>
          <div className="text-[9px] text-slate-400">{b.year}</div>
        </div>
        <SaveButton race={race} onChange={onSaveChange} className="absolute top-3 right-3 z-10" />
        {race.is_demo && (
          <span className="absolute top-3 left-1/2 -translate-x-1/2 bg-[#22d3ee] text-[#0a1420] text-[10px] font-black uppercase tracking-wider px-2.5 py-1 rounded z-10 shadow" data-testid="demo-badge">Demo</span>
        )}
        {race.featured && (
          <span className="absolute bottom-3 left-3 bg-[#22d3ee] text-[#0a1420] text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded z-10">Featured</span>
        )}
      </div>
      <div className="p-5 flex-1 flex flex-col">
        <h3 className="font-display font-bold uppercase tracking-wide text-lg text-[#0f172a] leading-tight line-clamp-2">
          <Link to={`/race/${race.slug}`} className="hover:text-[#06b6d4]">{race.name}</Link>
        </h3>
        <div className="flex items-center gap-2 mt-2 text-sm text-slate-600">
          <SportIcon sport={race.sport} size={15} className="text-[#06b6d4]" />
          <span className="font-medium">{sportName(race.sport)}</span>
          <span className="text-slate-300">·</span>
          <MapPin size={14} className="text-slate-400" />
          <span className="truncate">{race.city}</span>
        </div>
        {distances.length > 0 && (
          <div className="flex flex-wrap gap-1.5 mt-3">
            {distances.map((d) => (
              <span key={d} className="font-mono-data text-xs font-bold bg-slate-100 text-slate-800 px-2 py-0.5 rounded-md border border-slate-200">{d}</span>
            ))}
          </div>
        )}
        <Link to={`/race/${race.slug}`} data-testid={`view-race-${race.slug}`}
          className="mt-auto pt-4">
          <span className="w-full bg-[#0a1420] hover:bg-[#22d3ee] hover:text-[#0a1420] text-white font-bold py-2.5 px-4 rounded-lg transition-colors flex items-center justify-center gap-2 text-sm uppercase tracking-wider">
            View Race <ArrowRight size={16} />
          </span>
        </Link>
      </div>
    </div>
  );
}
